/*
  ogSetFocus can set the focus to the first focusable children of the element how call the method.
  ogSetFocus can receive as attribute a classname or id of a DOM element, and in this case, the focus will be set to that element.
*/

function ogSetFocus($timeout) {
  return {
    restrict: 'A',
    link: ($scope, elem, attrs) => {
      angular.element($timeout(() => {
        const selector = attrs.ogSetFocus;
        let selectedElement = (selector) ? elem[0].querySelector(selector) : null;
        /*
        'elem[0].querySelector' is used instead 'angular.element', because we want just the elements that are childrens of the elem scope
        */

        if (!selectedElement || selectedElement.disabled) {
          selectedElement = elem[0].querySelector('a[href]:not([tabindex="-1"]), area[href]:not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), iframe:not([tabindex="-1"]), object:not([tabindex="-1"]), embed:not([tabindex="-1"]), [contenteditable], [tabindex="0"]');
        }

        if (selectedElement) {
          selectedElement.focus();
        }
      }));
    }
  };
}

ogSetFocus.$inject = ['$timeout'];

module.exports = ogSetFocus;
